module.exports = __webpack_public_path__ + "img/Size=20, Style=light.39357f78.svg";